<template>
	<div class="set-category">
		<category-list
			title="1차 카테고리"
			:list="category1st"
			selection="category1st"
			:select-action="selectCategory1st"
		/>
		<category-list
			title="2차 카테고리"
			:list="category2nd"
			selection="category2nd"
			:select-action="selectCategory2nd"
		/>
		<category-list
			title="3차 카테고리"
			:list="category3rd"
			selection="category3rd"
			:select-action="selectCategory3rd"
		/>

		<section class="set-category__section set-category__info">
			<h1 class="set-category__info__h1">{{ categoryNames }}</h1>
			<h2 class="set-category__info__h2">기본정보</h2>
			<table
				:class="[
					'set-category__info__table',
					{
						'set-category__info__table--hide':
							categoryNamesArray.length === 0,
					},
				]"
			>
				<tbody>
					<tr class="set-category__info__tr">
						<th class="set-category__info__th">카테고리명</th>
						<td class="set-category__info__td">
							<a
								v-if="categoryInfo.id === 'entire'"
								target="_blank"
								:href="`${$store.state.env.adminDomain}/product/product-list?${queryString}`"
								class="set-category__info__a"
								>전체</a
							>
							<label v-else>
								<input
									v-model="categoryText"
									type="text"
									placeholder="카테고리명"
								/>
							</label>
						</td>
					</tr>
					<tr
						v-if="
							currentSelectedDepth !== 'category1st' &&
							categoryInfo.id !== 'entire'
						"
						class="set-category__info__tr"
					>
						<th class="set-category__info__th">대체 카테고리명</th>
						<td class="set-category__info__td">
							<label>
								<input
									v-model="shortText"
									type="text"
									placeholder="대체 카테고리명"
								/>
							</label>
						</td>
					</tr>
					<tr
						v-if="
							currentSelectedDepth !== 'category1st' &&
							categoryInfo.id !== 'entire'
						"
						class="set-category__info__tr"
					>
						<th class="set-category__info__th">홈타이틀</th>
						<td class="set-category__info__td">
							<label>
								<input
									v-model="shortWording"
									type="text"
									placeholder="홈타이틀"
								/>
							</label>
						</td>
					</tr>
					<tr
						v-if="categoryInfo.id !== 'entire'"
						class="set-category__info__tr"
					>
						<th class="set-category__info__th">등록일시</th>
						<td class="set-category__info__td">
							{{ createdDate }}
						</td>
					</tr>
					<tr class="set-category__info__tr">
						<th class="set-category__info__th">제품수</th>
						<td class="set-category__info__td">
							<span v-if="categoryInfo.id === 'entire'">
								{{ categoryCount | currency }}
							</span>
							<a
								v-else
								target="_blank"
								:href="`${$store.state.env.adminDomain}/product/product-list?${queryString}`"
								class="set-category__info__a"
							>
								{{ categoryCount | currency }}
							</a>
						</td>
					</tr>
					<tr
						v-if="categoryInfo.id !== 'entire'"
						class="set-category__info__tr"
					>
						<th class="set-category__info__th">노출여부</th>
						<td class="set-category__info__td">
							<toggleswitch-box
								@changingVal="changeIsDisplay"
								:checkSts="categoryIsDisplay"
								:checkObj="{ value: true, text: '노출' }"
								:unCheckObj="{ value: false, text: '미노출' }"
							/>
						</td>
					</tr>
					<tr
						v-if="categoryInfo.id !== 'entire'"
						class="set-category__info__tr"
					>
						<th class="set-category__info__th">New 표시</th>
						<td class="set-category__info__td">
							<toggleswitch-box
								:checkSts="categoryIsNew"
								@changingVal="changeIsNew"
								:checkObj="{ value: true, text: '표시' }"
								:unCheckObj="{ value: false, text: '비표시' }"
							/>
						</td>
					</tr>
					<tr
						v-if="currentSelectedDepth === 'category2nd'"
						class="set-category__info__tr"
					>
						<th class="set-category__info__th">
							3차 카테고리 전체표시
						</th>
						<td class="set-category__info__td">
							<toggleswitch-box
								:checkSts="showEntireCategories"
								@changingVal="changeShowEntireCategories"
								:checkObj="{ value: true, text: '표시' }"
								:unCheckObj="{ value: false, text: '비표시' }"
							/>
						</td>
					</tr>
					<tr
						v-if="currentSelectedDepth === 'category1st'"
						class="set-category__info__tr"
					>
						<th class="set-category__info__th">이미지</th>
						<td
							class="set-category__info__td set-category__info__image"
						>
							<img
								v-if="!previewImage"
								:src="categoryImage"
								alt=""
							/>
							<img
								v-else
								:src="previewImage"
								alt="업로드 이미지 미리보기"
							/>
							<input
								ref="categoryImage"
								type="file"
								accept="image/*"
								class="set-category__info__image-change-button"
								@change="uploadImage($event, 'iconUpload')"
							/>
						</td>
					</tr>
					<tr
						v-if="currentSelectedDepth === 'category1st'"
						class="set-category__info__tr"
					>
						<th class="set-category__info__th">
							랭킹모듈 배경이미지
						</th>
						<td
							class="set-category__info__td set-category__info__image"
						>
							<img
								v-if="!previewRankingImage"
								:src="rankingImage"
								alt=""
							/>
							<img
								v-else
								:src="previewRankingImage"
								alt="업로드 이미지 미리보기"
							/>
							<input
								ref="rankingImage"
								type="file"
								accept="image/*"
								class="set-category__info__image-change-button"
								@change="uploadImage($event, 'backUpload')"
							/>
						</td>
					</tr>
					<tr v-if="categoryInfo.id !== 'entire'">
						<td
							colspan="2"
							class="set-category__info__button-wrapper"
						>
							<button
								class="set-category__info__set-modify btn red"
								@click="deleteCategory"
							>
								카테고리 삭제
							</button>
							<button
								class="set-category__info__set-modify btn blue"
								@click="saveModify"
							>
								변경된 사항 적용
							</button>
						</td>
					</tr>
				</tbody>
			</table>

			<h2 class="set-category__info__h2">키워드 관리</h2>
			<table
				v-if="
					currentSelectedDepth === 'category2nd' ||
					currentSelectedDepth === 'category3rd'
				"
				:class="[
					'set-category__info__table',
					{
						'set-category__info__table--hide':
							categoryNamesArray.length === 0,
					},
				]"
			>
				<tbody>
					<tr class="set-category__info__tr">
						<th class="set-category__info__th">
							검색 키워드({{ searchKeywordsLength }})
						</th>
						<td
							class="set-category__info__td set-category__info__td--has-textarea"
						>
							<button
								class="btn blue bordered set-category__info__modify-button"
								@click="toggleCategoryModifySearchKeywords"
							>
								변경
							</button>
							<textarea disabled="disabled">{{
								searchKeywords
							}}</textarea>
						</td>
					</tr>
					<tr class="set-category__info__tr">
						<th
							class="set-category__info__th"
							v-text="`달파 키워드(${dalphaKeywordsLength})`"
						/>
						<td
							class="set-category__info__td set-category__info__td--has-textarea"
						>
							<button
								type="button"
								class="btn blue bordered set-category__info__modify-button"
								v-text="'변경'"
								@click="toggleModalDisplayDalphaKeyword"
							/>
							<textarea
								disabled="disabled"
								v-text="dalphaKeywords"
							/>
						</td>
					</tr>
					<tr class="set-category__info__tr">
						<th class="set-category__info__th">리뷰 키워드</th>
						<td
							class="set-category__info__td set-category__info__td--has-textarea"
						>
							<toggleswitch-box
								:checkSts="categoryIsReviewKeyword"
								@changingVal="changeIsReviewKeyword"
								:checkObj="{ value: true, text: 'On' }"
								:unCheckObj="{ value: false, text: 'Off' }"
							/>
							<button
								class="btn blue bordered set-category__info__modify-button"
								@click="toggleCategoryModifyReviewKeywords"
							>
								변경
							</button>
							<textarea>{{ reviewKeywords }}</textarea>
						</td>
					</tr>
				</tbody>
			</table>

			<h2 class="set-category__info__h2">유의어 관리</h2>
			<table
				v-if="
					currentSelectedDepth === 'category2nd' ||
					currentSelectedDepth === 'category3rd'
				"
				:class="[
					'set-category__info__table',
					{
						'set-category__info__table--hide':
							categoryNamesArray.length === 0,
					},
				]"
			>
				<tbody>
					<tr class="set-category__info__tr">
						<th class="set-category__info__th">
							유의어({{ aliasKeywordLength }})
							<p class="set-category__info__th__desc">
								콤마(,)로 구분
							</p>
						</th>
						<td
							class="set-category__info__td set-category__info__td--has-textarea alias-keyword"
						>
							<textarea
								v-model="aliasKeyword"
								class="alias-keyword__textarea"
							/>
							<div class="alias-keyword__button-box">
								<button class="btn" @click="initAliasKeyword">
									초기화
								</button>
								<button
									class="btn blue bordered"
									@click="modifyAliasKeyword"
								>
									변경
								</button>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</section>
	</div>
</template>
<script>
	import compact from 'lodash/compact';
	import debounce from 'lodash/debounce';
	import moment from 'moment';
	import CategoryList from '@/components/category/CategoryList';
	import ToggleswitchBox from '@/components/ToggleswitchBox';
	import { getImagePath } from '@/util';

	export default {
		name: 'setCategory',
		data() {
			return {
				previewImage: null,
				previewImageExtension: null,
				previewImageFileName: null,
				shortText: null,
				shortWording: null,
				categoryText: null,
				aliasKeyword: '',
				aliasKeywordOrigin: '',
				previewRankingImage: null,
				previewRankingExtension: null,
				previewRankingFileName: null,
			};
		},
		components: {
			CategoryList,
			ToggleswitchBox,
		},
		computed: {
			categoryInfo() {
				// 현재 선택된 카테고리 세부 정보를 반환
				this.previewImage = null; // 다른 정보를 불러올때 마다 이미지 미리보기 초기화
				this.previewImageExtension = null;
				this.previewImageFileName = null;
				this.previewRankingImage = null;
				this.previewRankingExtension = null;
				this.previewRankingFileName = null;
				this.aliasKeyword = '';

				const currentSelected =
					this.$store.getters['category/getCurrentSelected'];
				this.shortText = currentSelected.shortText;
				this.shortWording = currentSelected.shortWording;
				this.categoryText = currentSelected.name;

				this.getAliasKeyword(currentSelected);

				return currentSelected;
			},
			categoryCount() {
				if (
					Object.keys(this.categoryInfo).length !== 0 &&
					this.categoryInfo.productCount !== null
				) {
					return this.categoryInfo.productCount;
				}

				return 0;
			},
			category1st() {
				// 1차 카테고리 목록을 반환
				return this.$store.getters['category/getCategory1st'];
			},
			category2nd() {
				// 2차 카테고리 목록을 반환
				return this.$store.getters['category/getCategory2nd'];
			},
			category3rd() {
				// 3차 카테고리 목록을 반환
				return this.$store.getters['category/getCategory3rd'];
			},
			categoryNamesArray() {
				// 단계별 카테고리 이름을 배열로 반환
				// ex) ['스킨케어', '로션']
				return this.$store.getters['category/getSelectedCategoryNames'];
			},
			categoryNames() {
				// 단계별 카테고리 이름을 문자열로 반환
				// ex) 스킨케어 > 로션
				const names = this.categoryNamesArray;

				if (names.length === 0) {
					return '-';
				} else {
					return this.$store.getters[
						'category/getSelectedCategoryNames'
					].join(' > ');
				}
			},
			queryString() {
				// 제품수 클릭시 제품 검색으로 링크를 위한 쿼리 스트링
				// firstCategory=1&secondCategory=2 와 같은 형식으로 문자열을 반환
				const firstCategory =
					this.$store.state.category.selection.category1st;
				const secondCategory =
					this.$store.state.category.selection.category2nd;
				const thirdCategory =
					this.$store.state.category.selection.category3rd;
				const queries = [];

				if (!!firstCategory) {
					queries.push(`firstCategory=${firstCategory}`);
				}

				if (!!secondCategory) {
					queries.push(`secondCategory=${secondCategory}`);
				}

				if (!!thirdCategory && this.categoryInfo.id !== 'entire') {
					queries.push(`thirdCategory=${thirdCategory}`);
				}

				return queries.join('&');
			},
			createdDate() {
				// DB 로부터 받은 날짜를 YYYY-MM-DD 형식으로 변환하여 반환
				if (!!this.categoryInfo && !!this.categoryInfo.createdDate) {
					return moment(this.categoryInfo.createdDate * 1000).format(
						'YYYY-MM-DD'
					);
				} else {
					return '';
				}
			},
			categoryIsDisplay() {
				// 제품 상세정보의 노출여부를 반환
				if (!!this.categoryInfo) {
					return this.categoryInfo.isDisplay;
				} else {
					return false;
				}
			},
			categoryIsNew() {
				// 제품 상세정보의 New 표시 여부를 반환
				if (!!this.categoryInfo) {
					return this.categoryInfo.isNew;
				} else {
					return false;
				}
			},
			showEntireCategories() {
				if (!!this.categoryInfo) {
					return this.categoryInfo.showMergedChildren;
				} else {
					return false;
				}
			},
			searchKeywords() {
				// 제품 상세정보의 검색 키워드 목록을 문자열로 반환
				if (!!this.categoryInfo && !!this.categoryInfo.keyword) {
					return this.categoryInfo.keyword;
				} else {
					return '';
				}
			},
			searchKeywordsLength() {
				// 제품 상세정보의 검색 키워드의 수를 반환
				if (!this.categoryInfo.searchKeywordsArray) {
					return 0;
				}

				return this.categoryInfo.searchKeywordsArray.length;
			},
			dalphaKeywords() {
				return this.categoryInfo.dalphaKeyword || '';
			},
			dalphaKeywordsLength() {
				// 제품 상세정보의 달파 키워드의 수를 반환
				return this.dalphaKeywords.split(',').length;
			},
			reviewKeywords() {
				// 제품 상세정보의 리뷰 키워드를 문자열로 반환
				if (!!this.categoryInfo && !!this.categoryInfo.reviewKeyword) {
					return this.categoryInfo.reviewKeyword;
				} else {
					return '';
				}
			},
			categoryIsReviewKeyword() {
				// 제품 상세정보의 리뷰 키워드의 On / Off 여부를 반환
				if (
					!!this.categoryInfo &&
					typeof this.categoryInfo.isReviewKeyword === 'boolean'
				) {
					return this.$store.getters['category/getIsReviewKeyword'];
				} else {
					return false;
				}
			},
			categoryImage() {
				if (!!this.categoryInfo.image) {
					return this.categoryInfo.image;
				} else {
					return '';
				}
			},
			rankingImage() {
				if (!!this.categoryInfo.bgImageUrl) {
					return this.categoryInfo.bgImageUrl;
				} else {
					return '';
				}
			},
			currentSelectedDepth() {
				return this.$store.state.category.selection.depth;
			},
			aliasKeywordLength() {
				return compact(this.aliasKeyword.split(',')).length;
			},
		},
		created() {
			this.load1stCategories();
		},
		methods: {
			load1stCategories() {
				// 1차 카테고리 목록 로드
				this.$axiosAdmin2
					.get('/api/categories/level/1')
					.then(({ data }) => {
						const categories = data.data;
						_.each(categories, category => {
							category.id = category.idFirstCategory;
							category.name = category.firstCategoryText;
						});

						this.$store.commit('category/setCategory', {
							selection: 'category1st',
							data: categories,
						});
						this.$store.commit('toggleSpinner', false);
					});
			},
			selectCategory1st(id) {
				// 1차 카테고리 선택시 동작
				this.$store.commit('toggleSpinner', true);

				this.$axiosAdmin2
					.get(`/api/categories/level/2?idParentCategory=${id}`)
					.then(({ data }) => {
						const categories = data.data;
						_.each(categories, category => {
							category.id = category.idSecondCategory;
							category.name = category.secondCategoryText;
							category.shortText =
								category.secondCategoryShortText;
						});

						this.$store.commit('category/changeSelection', {
							id,
							depth: 'category1st',
							subCategories: categories,
						});

						this.$store.commit('toggleSpinner', false);
					});
			},
			selectCategory2nd(id) {
				// 2차 카테고리 선택시 동작
				this.$store.commit('toggleSpinner', true);

				this.$store.commit('category/changeSelection', {
					id,
					depth: 'category2nd',
				});

				this.$axiosAdmin2
					.get(`/api/categories/level/3?idParentCategory=${id}`)
					.then(({ data }) => {
						const categories = data.data;
						_.each(categories, category => {
							category.id = category.idThirdCategory;
							category.name = category.thirdCategoryText;
							category.shortText =
								category.thirdCategoryShortText;
						});
						this.$store.commit('category/changeSelection', {
							id,
							depth: 'category2nd',
							subCategories: categories,
						});

						this.$store.commit('toggleSpinner', false);
					});
			},
			selectCategory3rd(id) {
				this.$store.commit('category/changeSelection', {
					id,
					depth: 'category3rd',
				});
			},
			toggleCategoryModifySearchKeywords() {
				// 검색 키워드 수정 모달 열기
				this.$store.commit('modal/toggleModal', {
					id: 'CategoryModifySearchKeywords',
				});
			},
			toggleModalDisplayDalphaKeyword() {
				this.$store.commit('modal/toggleModal', {
					id: 'DisplayDalphaKeyword',
				});
			},
			toggleCategoryModifyReviewKeywords() {
				// 리뷰 키워드 수정 모달 열기
				this.$store.commit('toggleSpinner', true);

				this.$axiosAdmin2
					.get(
						`/api/categories/level/${this.categoryInfo.level}/category/${this.categoryInfo.id}/review-keywords`
					)
					.then(({ data }) => {
						this.$store.commit('category/setReviewKeywords', {
							data: data.data,
						});

						this.$store.commit('modal/toggleModal', {
							id: 'CategoryModifyReviewKeywords',
						});

						this.$store.commit('toggleSpinner', false);
					});
			},
			changeIsDisplay(event) {
				// 노출여부 변경
				this.$store.commit('category/changeIsDisplay', {
					value: event.value,
				});
			},
			changeIsNew(event) {
				// New 표시 변경
				this.$store.commit('category/changeIsNew', {
					value: event.value,
				});
			},
			changeShowEntireCategories(event) {
				this.$store.commit('category/changeShowEntireCategories', {
					value: event.value,
				});
			},
			changeIsReviewKeyword($event) {
				const categoryId = this.categoryInfo.id;
				this.$store.commit('toggleSpinner', true);

				this.$store
					.dispatch('category/changeIsReviewKeyword')
					.then(res => {
						if (res === $event.value) {
							this.$axios
								.put(
									`/lambda/admin/category/reviewKeyword/${categoryId}/enabled`,
									{
										isReviewKeyword: $event.value,
									}
								)
								.then(() => {
									this.$store.commit('toggleSpinner', false);
								});
						} else {
							this.$store.commit('toggleSpinner', false);
						}
					});
			},
			async saveModify() {
				if (this.categoryText.trim().length === 0) {
					alert('카테고리명을 입력해주세요.');
					return false;
				} else if (
					this.$store.getters['category/isCategoryNameDuplicate'](
						this.categoryText
					)
				) {
					alert('이미 등록된 카테고리명입니다.');
					return false;
				}

				if (!!this.previewImage) {
					this.$store.commit('category/setImage', {
						value: this.previewImage,
						ext: this.previewImageExtension,
						name: this.previewImageFileName,
					});
				}

				if (!!this.previewRankingImage) {
					this.$store.commit('category/setBackImage', {
						value: this.previewRankingImage,
						ext: this.previewRankingExtension,
						name: this.previewRankingFileName,
					});
				}

				const current =
					this.$store.getters['category/getCurrentSelected'];
				const data = {};

				data.categoryText = this.categoryText;
				data.idCategory = current.id;
				data.isDisplay = current.isDisplay;
				data.isNew = current.isNew;

				if (current.level === 2) {
					data.showMergedChildren = current.showMergedChildren;
				}

				data.sortKey = current.sortKey;
				data.categoryShortText =
					current.level === 1 ? null : this.shortText;
				data.shortWording =
					current.level === 1 ? null : this.shortWording;

				if (
					!!current.image &&
					!!current.imageExt &&
					!!current.imageName
				) {
					const response = await this.$axiosAdmin2.post(
						'/api/common/image',
						{
							data: current.image,
							extension: current.imageExt,
							fileName: current.imageName,
							target: 'category',
						}
					);

					data.fileDir = response.data.data.fileDir;
					data.fileSaveName = response.data.data.fileSaveName;
				} else {
					data.fileDir = null;
					data.fileSaveName = null;
				}

				if (
					!!current.backImage &&
					!!current.backImageExt &&
					!!current.backImageName
				) {
					const response = await this.$axiosAdmin2.post(
						'/api/common/image',
						{
							data: current.backImage,
							extension: current.backImageExt,
							fileName: current.backImageName,
							target: 'category',
						}
					);
					const file = response.data.data;
					data.bgImageUrl = getImagePath(
						file.fileDir,
						file.fileSaveName
					);
				} else {
					data.bgImageUrl = null;
				}

				this.$axiosAdmin2
					.post(`/api/categories/level/${current.level}`, data)
					.then(({ data }) => {
						alert('변경사항이 적용되었습니다.');
						this.$store.commit('category/changeNames', {
							longName: this.categoryText,
							shortName: this.shortText,
							shortWording: this.shortWording,
						});

						if (current.level === 2) {
							this.$store.commit(
								'category/updateCategory3rd',
								current
							);
						}

						this.$store.commit('toggleSpinner', false);
					})
					.catch(({ response }) => {
						console.error(response);

						if (response && response.status === 500) {
							alert(response.data.message);
							this.categoryInfo.isDisplay = false;
						} else {
							alert(
								'저장에 실패하였습니다. 지속적인 문제 발생시 개발팀에 문의바랍니다. '
							);
						}
					});
			},
			uploadImage($event, name) {
				const image = $event.target.files[0];
				const reader = new FileReader();
				reader.readAsDataURL(image);

				if (name === 'iconUpload') {
					if (image.size > 1024 * 1024) {
						this.$refs.categoryImage.value = null;
						alert('이미지는 1메가까지 등록이 가능합니다.');
						return false;
					}

					this.previewImageExtension = image.type.split('/').pop();
					this.previewImageFileName = image.name;

					reader.onload = event => {
						this.previewImage = event.target.result;
					};
				} else {
					this.previewRankingExtension = image.type.split('/').pop();
					this.previewRankingFileName = image.name;
					reader.onload = event => {
						const file = new Image();
						this.previewRankingImage = event.target.result;
						file.src = this.previewRankingImage;

						file.onload = () => {
							const width = file.width;
							const height = file.height;
							const ratio = width / height;
							if (ratio !== 1) {
								alert('사이즈 비율이 1:1만 업로드 가능합니다.');
								this.$refs.rankingImage.value = null;
								this.previewRankingImage = null;
								return false;
							}
						};
					};
				}
			},
			deleteCategory() {
				const level = this.categoryInfo.level;
				const idCategory = this.categoryInfo.id;
				if (this.categoryInfo.productCount > 0) {
					alert(
						'카테고리에 등록된 제품이 있습니다. 등록된 제품을 확인하세요'
					);
				} else if (confirm('카테고리를 삭제하시겠습니까?')) {
					this.$axiosAdmin2
						.delete(`/api/categories/level/${level}/${idCategory}`)
						.then(({ data }) => {
							this.$store.commit('category/deleteCategory');
						});
				}
			},
			getAliasKeyword: debounce(async function ({ id, level }) {
				try {
					if (!id || level === 1) {
						return;
					}
					const {
						data: { keyword },
					} = await this.$axiosAdmin2.get(
						`/v3/api/category/level/${level}/${id}/aliasKeyword`
					);
					this.aliasKeyword = keyword || '';
					this.aliasKeywordOrigin = keyword || '';
				} catch (err) {
					console.error(err);
				}
			}, 700),
			initAliasKeyword() {
				this.aliasKeyword = this.aliasKeywordOrigin;
			},
			async modifyAliasKeyword() {
				try {
					const params = { keyword: this.aliasKeyword };
					await this.$axiosAdmin2.post(
						`/v3/api/category/level/${this.categoryInfo.level}/${this.categoryInfo.id}/aliasKeyword`,
						params
					);
					alert('변경되었습니다.');
				} catch (err) {
					console.error(err);
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.set-category {
		display: flex;
		width: 100%;
	}

	.set-category__section {
		flex: 1;
	}

	body {
		.set-category__info {
			padding: 1em;
		}

		.set-category__info__table {
			table-layout: fixed;
			opacity: 1;
			margin-bottom: 1em;
			overflow: hidden;
		}

		.set-category__info__table--hide {
			opacity: 0;
		}

		.set-category__info__h1 {
			font-size: 1em;
			font-weight: bold;
			margin-bottom: 1em;
			padding-top: 2em;
			color: #303643;
		}

		.set-category__info__h2 {
			padding: 1em;
			border-bottom: 1px solid #ebebed;
		}

		.set-category__info__th {
			padding: 1em 0 1em 1em;
			font-weight: bold;
			background: #f4f7fa;
			color: #657088;
			border-bottom: 1px solid #ebebed;
		}

		.set-category__info__td {
			vertical-align: middle;
			padding-left: 1em;
			border-bottom: 1px solid #ebebed;
		}

		.set-category__info__td--has-textarea {
			padding-top: 1em;

			.toggleswitch-box {
				margin-bottom: 1em;
			}
		}

		.set-category__info__image {
			text-align: center;

			.btn {
				margin-bottom: 1em;
			}
		}

		.set-category__info__image-change-button {
			margin: auto;
		}

		.set-category__info__modify-button {
			margin-bottom: 1em;
		}

		.set-category__info__button-wrapper {
			padding: 1em 0;
			text-align: center;

			.btn {
				display: inline-block;
			}

			.red {
				background: $red;
				color: #fff;
				border: #fff;
			}
		}

		.set-category__info__set-modify {
			cursor: pointer;
		}

		.set-category__info__a {
			text-decoration: underline;
			color: $btn-blue;
		}
	}

	.set-category__info__th__desc {
		font-weight: normal;
	}

	.alias-keyword__textarea {
		margin-bottom: 1em;
	}

	.alias-keyword__button-box {
		display: flex;
		justify-content: space-between;
	}
</style>
